import { Component, Input } from '@angular/core';
import { I18nService } from '@app/core';

@Component({
    selector: 'app-goal-box-statistics-column-widget',
    templateUrl: './widget.component.html',
    styleUrls: ['./widget.component.scss'],
    standalone: false,
})
export class GoalBoxStatisticsColumnWidgetComponent {
    @Input() current!: number;
    @Input() declarated!: number;
    @Input() achieved!: boolean;
    @Input() missed!: boolean;

    svgStrokeMax = 482;

    // eslint-disable-next-line @angular-eslint/prefer-inject
    constructor(private i18nService: I18nService) {}

    get stroke(): number {
        const p = this.current / this.declarated > 1 ? 1 : this.current / this.declarated;
        return Math.floor(p * this.svgStrokeMax);
    }

    get class(): string {
        if (this.missed) {
            return 'danger';
        }
        if (this.achieved) {
            return 'success';
        }
        return 'info';
    }

    get currentLanguage(): string {
        return this.i18nService.language;
    }
}
